module.exports = __webpack_public_path__ + "img/user.7aea9cc8.png";